import React from 'react';
import { FileText, ThumbsUp, MessageSquare, CalendarCheck, FileEdit, Info } from 'lucide-react';

export default function RecentActivity({ activities = [] }) {
  // Funcție care returnează textul pentru tipul activității
  const renderActivityText = (act) => {
    switch (act.type) {
      case "propunere":
        return <span>a propus un nou proiect</span>;
      case "voteaza":
        return <span>a votat pentru</span>;
      case "comenteaza":
        return <span>a comentat la</span>;
      case "inscriere":
        return <span>s-a înscris la evenimentul</span>;
      case "amendament":
        return <span>a propus un amendament pentru</span>;
      default:
        return <span>a realizat o acțiune pentru</span>;
    }
  };

  // Iconițe moderne din lucide-react cu styling integrat
  const renderIcon = (type) => {
    const iconProps = { size: 18, color: "#fbbf24", strokeWidth: 2.5 };
    switch(type) {
      case "propunere":
        return <FileText {...iconProps} />;
      case "voteaza":
        return <ThumbsUp {...iconProps} />;
      case "comenteaza":
        return <MessageSquare {...iconProps} />;
      case "inscriere":
        return <CalendarCheck {...iconProps} />;
      case "amendament":
        return <FileEdit {...iconProps} />;
      default:
        return <Info {...iconProps} />;
    }
  };

  return (
    <div 
      style={{ 
        backgroundColor: "#1e293b", 
        borderRadius: "20px", 
        padding: "24px", 
        border: "1px solid rgba(255, 255, 255, 0.05)", 
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)", 
        height: "100%", 
        maxHeight: "460px", 
        overflowY: "auto" 
      }} 
      className="custom-scrollbar" // Această clasă se va folosi de CSS-ul definit în Dashboard.js
    >
      <h4 style={{ color: "#f8fafc", fontSize: "1.25rem", fontWeight: 700, marginBottom: "24px" }}>
        Activitate Recentă în PRDP
      </h4>
      
      {activities && activities.length > 0 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {activities.map((act, idx) => (
            <div 
              key={idx} 
              style={{ 
                display: "flex", 
                gap: "16px", 
                alignItems: "flex-start", 
                backgroundColor: "#0f172a", // Card individual mai închis
                padding: "16px", 
                borderRadius: "16px", 
                border: "1px solid rgba(255, 255, 255, 0.03)" 
              }}
            >
              {/* Container Iconiță cu fundal subtil */}
              <div 
                style={{ 
                  backgroundColor: "rgba(251, 191, 36, 0.1)", 
                  padding: "10px", 
                  borderRadius: "12px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  minWidth: "40px",
                  height: "40px"
                }}
              >
                {renderIcon(act.type)}
              </div>
              
              {/* Conținutul activității */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "0.9rem", color: "#94a3b8", lineHeight: "1.4", marginBottom: "4px" }}>
                  <strong style={{ color: "#f8fafc", fontWeight: 600 }}>{act.user}</strong> {renderActivityText(act)}
                </div>
                <div style={{ color: "#cbd5e1", fontSize: "0.95rem", fontWeight: 500, marginBottom: "6px" }}>
                  {act.detail}
                </div>
                <small style={{ color: "#64748b", fontSize: "0.8rem", display: "block", fontWeight: 500 }}>
                  {act.time}
                </small>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: "#64748b", fontStyle: "italic", textAlign: "center", padding: "20px 0" }}>
          Nu există activitate recentă momentan.
        </div>
      )}
    </div>
  );
}
